export const PAYLOAD_BUILDER_MONO_FONT =
  'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace';

export const PAYLOAD_BUILDER_ALERT_BUTTON_SX = {
  flexShrink: 0,
  width: { xs: '100%', sm: 'auto' },
} as const;
